import { load } from "@fingerprintjs/fingerprintjs";

const PROGRAM_KEY = 'currentProgram';
const PROGRAM_FETCH_TS_KEY = 'currentProgramFetchTs';

export const storageService = {
    loadProgram: () => {
        try {
            const serializedData = localStorage.getItem(PROGRAM_KEY);
            return serializedData ? JSON.parse(serializedData) : null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    saveProgram: (program) => {
        try {
            localStorage.setItem(PROGRAM_KEY, JSON.stringify(program));
        } catch (error) {
            console.error(error);
        }
    },
    loadProgramFetchTs: () => {
        try {
            const serializedData = localStorage.getItem(PROGRAM_FETCH_TS_KEY);
            return serializedData ? serializedData : null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    saveProgramFetchTs: (ts) => {
        try {
            localStorage.setItem(PROGRAM_FETCH_TS_KEY, ts);
        } catch (error) {
            console.error(error);
        }
    }
};
